import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { media } from '@breakpoints'
import Header from '@organisms/header'
import Footer from '@organisms/footer'
import { parseMarginOrPadding } from '@styles/helper'
import Consent from './consent'

const propTypes = {}

const LayoutCenter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: ${({ margin }) => parseMarginOrPadding(margin)};
  padding: ${({ padding }) => parseMarginOrPadding(padding)};
`

const LayoutContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: ${({ theme }) => `${theme.default.container}px`};
  padding: 0 1rem 1rem 1rem;
  margin: 0 auto;
`

const LayoutRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: ${(props) => (props.wrap ? 'wrap' : undefined)};
  justify-content: ${(props) => props.justify || 'center'};
  align-items: ${(props) => (props.center ? 'center' : undefined)};
  margin: ${({ margin }) => parseMarginOrPadding(margin)};
  padding: ${({ padding }) => parseMarginOrPadding(padding)};
`

const LayoutColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => {
    if (props.center) {
      return 'center'
    } else if (props.alignRight) {
      return 'flex-end'
    } else {
      return 'flex-start'
    }
  }};
  margin: ${({ margin }) => parseMarginOrPadding(margin)};
  padding: ${({ padding }) => parseMarginOrPadding(padding)};
`

const LayoutGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: ${(props) => {
    if (props.gridTemplate !== undefined) {
      return props.gridTemplate
    } else if (props.fixed !== undefined) {
      return `repeat(auto-fit, ${props.fixed}px)`
    } else if (props.min !== undefined) {
      return `repeat(auto-fit, minmax(${props.min}px, 1fr))`
    } else {
      return '1fr'
    }
  }};
  justify-content: ${(props) => props.justify};
  grid-gap: ${(props) => props.gap || 0}rem;
  grid-template-rows: ${(props) =>
    props.rows ? `repeat(${props.rows}, 1fr)` : undefined};

  margin: ${({ margin }) => parseMarginOrPadding(margin)};
  padding: ${({ padding }) => parseMarginOrPadding(padding)};

  ${media.phablet`
    grid-template-columns: 1fr;
  `}
`

const LayoutComponent = ({
  className,
  children,
  disableSearch,
  location,
  maxMedia
}) => {
  return (
    <div className={className}>
      <Header
        disableSearch={disableSearch}
        location={location}
        maxMedia={maxMedia}
      ></Header>
      <main style={{ width: '100%', flex: 1 }}>{children}</main>
      <Footer />
      <Consent />
    </div>
  )
}

LayoutComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  disableSearch: PropTypes.bool,
  location: PropTypes.any,
  maxMedia: PropTypes.string
}

const Layout = styled(LayoutComponent)`
  align-items: center;
  display: flex;
  width: 100%;
  flex-direction: column;
  min-height: 100vh;
  background: #f6f8fe;
  main {
    max-width: ${({ fullWidth, theme }) =>
      !fullWidth && `${theme.default.container}px`};
    padding: ${({ fullWidth }) => !fullWidth && `0 1rem 1rem 1rem`};
  }
  ${media.desktop` 
    main {
      padding: ${({ fullWidth }) => !fullWidth && `0 1rem`} ;
    }
  `}
`

Layout.propTypes = propTypes
Layout.Container = LayoutContainer
Layout.Center = LayoutCenter
Layout.Row = LayoutRow
Layout.Grid = LayoutGrid
Layout.Column = LayoutColumn
export default Layout
